<div class="bordered" *ngIf="list.itemCount">
  <div class="table">
    <div class="head-group sticky">
      <div class="row">
        <!-- cislo spisu -->
        <span class="cell" *ngIf="!hideColumn('folderNumber')">
          <sort-by
            [selected]="'folder.folderNumber' === list.filter.sortOrder.sortBy"
            (sort)="onSort('folder.folderNumber', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Číslo spisu EPD</sort-by>
        </span>

        <!-- cislo ZP -->
        <span class="cell" *ngIf="!hideColumn('name')">
          <sort-by
            [selected]="'name' === list.filter.sortOrder.sortBy"
            (sort)="onSort('name', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Číslo ZP</sort-by>
        </span>

        <!-- k.u. -->
        <span class="cell" *ngIf="!hideColumn('area')">
          <sort-by
            [selected]="'title.area.name' === list.filter.sortOrder.sortBy"
            (sort)="onSort('title.area.name', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Katastrální území</sort-by>
        </span>

        <!-- LV -->
        <span class="cell" *ngIf="!hideColumn('lv')">
          <sort-by
            [selected]="'title.lv' === list.filter.sortOrder.sortBy"
            (sort)="onSort('title.lv', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >LV</sort-by>
        </span>

        <!-- znalec -->
        <span class="cell" *ngIf="!hideColumn('expert')">
          <sort-by
            [selected]="'expert' === list.filter.sortOrder.sortBy"
            (sort)="onSort('expert', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Znalec</sort-by>
        </span>

        <!-- stav -->
        <span class="cell" *ngIf="!hideColumn('status')">
          <sort-by
            [selected]="'status' === list.filter.sortOrder.sortBy"
            (sort)="onSort('status', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Stav</sort-by>
        </span>

        <!-- vyhotoveni -->
        <span class="cell" *ngIf="!hideColumn('realizedDate')">
          <sort-by
            [selected]="'realizedDate' === list.filter.sortOrder.sortBy"
            (sort)="onSort('realizedDate', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Datum vyhotovení</sort-by>
        </span>

        <!-- zmena -->
        <span class="cell" *ngIf="!hideColumn('changedDate')">
          <sort-by
            [selected]="'changedDate' === list.filter.sortOrder.sortBy"
            (sort)="onSort('changedDate', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Datum poslední změny</sort-by>
        </span>

        <!-- zadani cen -->
        <span class="cell" *ngIf="!hideColumn('pricesFilledDate')">
          <sort-by
            [selected]="'pricesFilledDate' === list.filter.sortOrder.sortBy"
            (sort)="onSort('pricesFilledDate', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Datum vložení ZP</sort-by>
        </span>

        <!-- zadani cen -->
        <span class="cell" *ngIf="!hideColumn('pricesFilledUser')">Vložil</span>

        <!-- resene parcely -->
        <span class="cell" *ngIf="!hideColumn('parcels')">Řešené parcely</span>
      </div>
    </div>

    <div class="row-group">
      <a class="row" *ngFor="let opinion of list.list"  (click)="onClick(opinion)" [uiSref]="clickable ? undefined : 'symap.project.opinionRequests.detail'" [uiParams]="{ id: opinion.id, tab: 'parcels' }">

        <!-- cislo spisu -->
        <span *ngIf="!hideColumn('folderNumber')" class="cell">{{ opinion.folder && opinion.folder.folderNumber ? opinion.folder.folderNumber : '' }}</span>

        <!-- cislo ZP -->
        <span class="cell" *ngIf="!hideColumn('name')">{{ opinion.name }}</span>

        <!-- katastralni uzemi -->
        <span class="cell" *ngIf="!hideColumn('area')">
          {{ opinion.title && opinion.title.area ? opinion.title.area.name : '' }}
        </span>

        <!-- LV -->
        <span class="cell" *ngIf="!hideColumn('lv')">
          <a *ngIf="opinion.title" uiSref="symap.project.titles.detail" [uiParams]="{ id: opinion.title.id, tab: null }" (click)="$event.stopPropagation()">
            {{ opinion.title.lv }}
          </a>
        </span>

        <!-- znalec -->
        <span class="cell" *ngIf="!hideColumn('expert')">{{ opinion.expert | subjectName }}</span>

        <!-- stav -->
        <span class="cell" *ngIf="!hideColumn('status')">{{ requestService.getStatusEnumLabel(opinion.status) }}</span>

        <!-- vyhotoveni -->
        <span class="cell text-center" *ngIf="!hideColumn('realizedDate')">{{ opinion.realizedDate | date }}</span>

        <!-- změna -->
        <span class="cell text-center" *ngIf="!hideColumn('changedDate')">{{ opinion.changedDate | date }}</span>

        <!-- zadani cen -->
        <span class="cell text-center" *ngIf="!hideColumn('pricesFilledDate')">{{ opinion.pricesFilledDate | date }}</span>

        <!-- zadani cen -->
        <span class="cell text-center" *ngIf="!hideColumn('pricesFilledUser')">{{ opinion.pricesFilledUser | username }}</span>

        <!-- resene parcely -->
        <span class="cell no-padding" *ngIf="!hideColumn('parcels')">
          <cell-parcels
            [countParcels]="opinion.countParcels"
            [tooltipType]="'parcels'"
            [tooltipData]="{ filter: { filters: { opinionRequestId: opinion.id }}}"
          ></cell-parcels>
        </span>
      </a>
    </div>
  </div>
</div>
